// extracted by mini-css-extract-plugin
module.exports = {"content":"TenderAdd_content__22IaQ","body":"TenderAdd_body__D8M86"};